<template>
  <div class="reward">
    <transition name="slide-fade">
      <div class="page-header disFlex fvc" v-if="currentType==1">
        <img src="https://j.weizan.cn/youxiang/header-bg.png" class="bg-img" />
        <div>总奖励金额：{{total}}元</div>
      </div>
    </transition>

    <div class="page-body" :class="{'all-page-class':currentType!=1}">
      <div class="body-header disFlex fc frd">
        <div
          class="head-item disFlex vertical fvc"
          :class="{'active-item':currentType===1}"
          @click="changeType(1)"
        >
          <div>有效浏览（{{availableDataTotal}}）</div>
          <div class="line" :class="{'active-line':currentType===1}"></div>
        </div>
        <div
          class="head-item disFlex vertical fvc"
          :class="{'active-item':currentType===2}"
          @click="changeType(2)"
        >
          <div>无效浏览（{{unAvailableDataTotal||0}}）</div>
          <div class="line" :class="{'active-line':currentType===2}"></div>
        </div>
      </div>

      <div class="body-detail body-detail1" v-if="currentType==1">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="loadmore">
          <div
            class="data-item disFlex fc Flex-between"
            v-for="(item,index) in availableDataList"
            :key="index"
          >
            <div class="data-left disFlex fc" style="max-width:82%;">
              <img :src="item.avatar" class="avatar" />
              <div class="data-detail disFlex vertical Flex-between">
                <div class="user-name">{{item.nickName}}</div>
                <div
                  class="data-info"
                >{{item.happenTime}} 丨 {{item.amount===0?item.description:(item.remark==='in_acount'?'入账余额':'自动到账')}}</div>
              </div>
            </div>
            <div class="data-right disFlex vertical Flex-between">
              <div class="data-price">+{{item.amount}}元</div>
              <div class="data-status">{{item.comment}}</div>
            </div>
          </div>
        </van-list>
      </div>
      <div class="body-detail" v-else-if="currentType==2">
        <van-collapse v-model="activeNames">
          <van-collapse-item
            v-for="(item,index) in unAvailableDataList"
            :title="item.date+`（${item.item.length}次）`"
            :key="index"
            :name="item.date"
          >
            <div
              v-for="(user,userIdx) in item.item"
              :key="userIdx"
              class="data-item disFlex fc Flex-between"
            >
              <div class="data-left disFlex fc">
                <img :src="user.avatar" class="avatar" />
                <div class="data-detail disFlex vertical Flex-between">
                  <div class="user-name">{{user.nickName}}</div>
                  <div class="data-info">{{user.happenTime}}</div>
                </div>
              </div>
              <div class="data-right disFlex vertical Flex-between">
                <div class="data-reason">无效原因</div>
                <div class="reason-detail">{{user.remark}}</div>
              </div>
            </div>
          </van-collapse-item>
        </van-collapse>

        <div class="line"></div>
      </div>
    </div>
    <div class="f v fvc">
      <div class="back-btn" @click="goBack">返回</div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      currentType: 1,
      activeNames: [],
      total: 0,
      availableDataList: [],
      availableDataTotal: 0,
      unAvailableData: {},
      currentPage: 1,
      finished: false,
      loading: true,
    };
  },
  computed: {
    unAvailableDataList: function () {
      let tmp = [];
      Object.keys(this.unAvailableData).forEach((i, idx) => {
        tmp[idx] = {
          date: /\d{4}-\d{1,2}-\d{1,2}/g.exec(i)[0],
        };
      });
      Object.values(this.unAvailableData).forEach((i, idx) => {
        Object.assign(tmp[idx], {
          item: i,
        });
      });
      return tmp;
    },
    unAvailableDataTotal: function () {
      let tmp = 0;
      this.unAvailableDataList.forEach((i) => {
        tmp = tmp + i.item.length;
      });
      return tmp;
    },
  },
  created() {
    this.getAvailableUser();
    this.getUnAvailableUser();
    this.getTotalMoney();
  },
  methods: {
    getTotalMoney() {
      this.$http.post("/v1/finance/withdraw/available_sum").then((res) => {
        if (res.code === 0) {
          this.total = res.data || 0;
        }
      });
    },
    loadmore() {
      if (!this.finished) {
        this.currentPage++;
        this.getAvailableUser();
      }
    },
    getUnAvailableUser() {
      this.$http.post("/v1/finance/withdraw/query_no_available").then((res) => {
        if (res.code === 0) {
          this.unAvailableData = res.data;
        }
      });
    },
    getAvailableUser() {
      this.$http
        .post("/v1/finance/withdraw/query_available", {
          page: this.currentPage,
          size: 10,
        })
        .then((res) => {
          this.loading = false;
          if (res.code === 10200) {
            this.finished = true;
          } else {
            this.availableDataList = this.availableDataList.concat(
              res.data.list
            );
            this.availableDataTotal = res.data.total;
          }
        });
    },
    changeType(e) {
      this.currentType = e;
      if (e === 1) {
        this.availableDataList = [];
        this.currentPage = 1;
        this.finished = false;
        this.getAvailableUser();
      }
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="less" scoped>
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s ease-in-out;
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}

.reward {
  width: 100%;
  position: relative;
  background: #003078;
  .page-header {
    padding: 0 15px;
    position: relative;
    height: 80px;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
    overflow: hidden;
    .bg-img {
      position: absolute;
      right: 0;
      top: 0;
      width: 151px;
      height: 190px;
    }
  }

  .page-body {
    min-height: calc(100vh - 80px);
    background: rgba(255, 255, 255, 1);
    border-radius: 15px 15px 0px 0px;
    .body-header {
      padding: 12px 16px 0;

      border-bottom: 1px solid #f5f6f7;
      .head-item {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #696969;
        .line {
          width: 20px;
          height: 2px;
          background: transparent;
          margin-top: 13px;
        }
        .active-line {
          background: rgba(0, 48, 120, 1) !important;
        }
      }
      .active-item {
        color: rgba(0, 48, 120, 1) !important;
      }
    }
    .body-detail1 {
      padding: 12px 16px 0;
      height: 68vh !important;
    }
    .body-detail {
      height: 79vh;
      overflow: scroll;
      .date-item {
        .date-header {
          border-bottom: 1px solid #f5f6f7;
          padding: 10px 0;
          .date-detail {
            font-size: 12px;
            font-family: PingFang SC;
            font-weight: 500;
            color: rgba(53, 53, 53, 1);
          }
          .down-arrow {
            width: 14px;
            height: 9px;
          }
        }
        .line {
          width: 100%;
          height: 5px;
          background: rgba(245, 246, 247, 1);
          position: relative;
          left: -16px;
        }
      }
      .data-item {
        padding: 20px 0;
        border-bottom: 1px solid #f5f6f7;
        .avatar {
          width: 44px;
          height: 44px;
          background: rgba(159, 159, 159, 1);
          border-radius: 50%;
          margin-right: 8px;
        }
        .data-left,
        .data-right,
        .data-detail {
          height: 44px;
          line-height: 1.2;
        }
        .data-right {
          text-align: right;
        }
        .user-name {
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: bold;
          color: rgba(53, 53, 53, 1);
        }
        .data-info {
          font-size: 12px;
          font-family: PingFang SC;
          font-weight: 500;
          color: rgba(105, 105, 105, 1);
        }
        .data-price {
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: bold;
          color: rgba(203, 151, 76, 1);
        }
        .data-status {
          font-size: 12px;
          font-family: PingFang SC;
          font-weight: 500;
          color: rgba(105, 105, 105, 1);
        }
        .data-reason {
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 500;
          color: rgba(105, 105, 105, 1);
        }
        .reason-detail {
          font-size: 12px;
          font-family: PingFang SC;
          font-weight: 500;
          color: rgba(105, 105, 105, 1);
        }
      }
    }
  }
  .back-btn {
    width: 315px;
    height: 44px;
    border: 1px solid rgba(0, 48, 120, 1);
    border-radius: 22px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);

    line-height: 44px;
    text-align: center;
    position: fixed;
    bottom: 26px;
    background: rgba(0, 48, 120, 1);
  }
  .all-page-class {
    border-radius: 0;
    background: #fff;
    min-height: 100vh !important;
  }
}
</style>